import moment from "moment/moment";

export const fromTodayStart = moment().startOf('day').toISOString()
export const toTodayEnd = moment().endOf('day').toISOString()

export const yearStart = moment().startOf('year').toISOString()
export const yearEnd = moment().endOf('year').toISOString()
export const lastYear = moment().subtract(1, 'year').toISOString()